import { IndustryScoreColors } from "../features/student_dashboard/industry_score/interfaces/IndustryScoreColors";
import greenChart from "./../assets/images/dashboard/dashboard_chart/green_chart.png";
import yellowChart from "./../assets/images/dashboard/dashboard_chart/yellow_chart.png";
import redChart from "./../assets/images/dashboard/dashboard_chart/pink_chart.png";
import jozunaLogo from "../assets/images/sidebarImages/logo.svg";
import greenScore from "../features/inventory_dashboard/assets/greenScore.png";
import yellowScore from "../features/inventory_dashboard/assets/yellowScore.png";
import redScore from "../features/inventory_dashboard/assets/redScore.png";
import greenTrend from "./../features2/dashboard/assets/greentrend.png";
import yellowTrend from "./../features2/dashboard/assets/yellowTrend.png";
import redTrend from "./../features2/dashboard/assets/redtrend.png";
import { BrowserInfo, BrowserType } from "../interface/BrowserTypeInterface";
import {
  isChrome,
  isFirefox,
  isSafari,
  isEdge,
  isOpera,
  browserVersion,
} from "react-device-detect";
import { format, parse } from "date-fns";

// At the top of your Common_Utils.ts file, make sure you have this:

const DB_NAME = "ExamoraDB";
const DB_VERSION = 2; // Increment version to force recreation
const STORES = ["examImages", "examScreenCaptures", "examAudio"] as const;

type StoreName = (typeof STORES)[number];

// Helper function to open DB and ensure stores exist
const openDB = (): Promise<IDBDatabase> => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = () => {
      console.error("IndexedDB error:", request.error);
      reject(request.error);
    };

    request.onsuccess = () => {
      console.log("IndexedDB opened successfully");
      resolve(request.result);
    };

    request.onupgradeneeded = (event) => {
      const db = request.result;
      console.log("Creating/upgrading IndexedDB stores...");

      // Create object stores if they don't exist
      STORES.forEach((storeName) => {
        if (!db.objectStoreNames.contains(storeName)) {
          const objectStore = db.createObjectStore(storeName, {
            keyPath: "id",
            autoIncrement: true,
          });
          // Create an index on timestamp for efficient querying
          objectStore.createIndex("timestamp", "timestamp", { unique: false });
          console.log(`Created object store: ${storeName}`);
        } else {
          console.log(`Object store already exists: ${storeName}`);
        }
      });
    };
  });
};

// Save media function with better error handling
export const saveMedia = async (
  storeName: StoreName,
  data: { timestamp: string; image?: string; audio?: string },
): Promise<void> => {
  try {
    console.log(`Saving to ${storeName} at ${data.timestamp}`);
    const db = await openDB();

    // Check if store exists
    if (!db.objectStoreNames.contains(storeName)) {
      console.error(`Object store ${storeName} does not exist!`);
      db.close();
      return;
    }

    const tx = db.transaction(storeName, "readwrite");
    const store = tx.objectStore(storeName);

    const request = store.add(data);

    return new Promise((resolve, reject) => {
      request.onsuccess = () => {
        console.log(
          `Successfully saved to ${storeName}, id: ${request.result}`,
        );
        resolve();
      };

      request.onerror = () => {
        console.error(`Failed to save to ${storeName}:`, request.error);
        reject(request.error);
      };

      tx.oncomplete = () => {
        console.log(`Transaction completed for ${storeName}`);
        db.close();
      };

      tx.onerror = () => {
        console.error(`Transaction error for ${storeName}:`, tx.error);
        reject(tx.error);
        db.close();
      };
    });
  } catch (err) {
    console.error(`Failed to save to ${storeName}:`, err);
  }
};

// Add a helper function to check what's in the database
export const getMediaCount = async (storeName: StoreName): Promise<number> => {
  try {
    const db = await openDB();
    if (!db.objectStoreNames.contains(storeName)) {
      console.warn(`Store ${storeName} doesn't exist yet`);
      db.close();
      return 0;
    }

    const tx = db.transaction(storeName, "readonly");
    const store = tx.objectStore(storeName);

    return new Promise((resolve) => {
      const request = store.count();
      request.onsuccess = () => {
        db.close();
        resolve(request.result);
      };
      request.onerror = () => {
        db.close();
        resolve(0);
      };
    });
  } catch (err) {
    console.error("Error getting count:", err);
    return 0;
  }
};

// Add a helper function to clear all data (useful for testing)
export const clearMediaStore = async (storeName: StoreName): Promise<void> => {
  try {
    const db = await openDB();
    if (!db.objectStoreNames.contains(storeName)) {
      console.warn(`Store ${storeName} doesn't exist yet`);
      db.close();
      return;
    }

    const tx = db.transaction(storeName, "readwrite");
    const store = tx.objectStore(storeName);
    const request = store.clear();

    return new Promise((resolve, reject) => {
      request.onsuccess = () => {
        console.log(`Cleared ${storeName} store`);
        db.close();
        resolve();
      };
      request.onerror = () => {
        console.error(`Failed to clear ${storeName}:`, request.error);
        db.close();
        reject(request.error);
      };
    });
  } catch (err) {
    console.error(`Error clearing ${storeName}:`, err);
  }
};

class CommonUtils {
  // Define a static property for month names
  static readonly monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];

  static formatAllRegionDate(dateString: string): string {
    const dateParts = dateString.split(",")[0].trim();
    const dateObj = new Date(dateParts);
    const day = dateObj.getDate().toString().padStart(2, "0");
    const month = CommonUtils.monthNames[dateObj.getMonth()];
    const year = dateObj.getFullYear();
    return `${day}-${month}-${year}`;
  }
static getBarClassbar(score: number) {
  if (score >= 80) return "#4CAF50";
  if (score >= 60) return "#FFC107";
  return "#FF5252";
}
  static getIndustryScoreColors(score: number): IndustryScoreColors {
    let backgroundColor: string;
    let percentColor: string;

    if (score >= 80) {
      backgroundColor = "#E3FFF5";
      percentColor = "#24C782";
    } else if (score >= 50 && score <= 79.99) {
      backgroundColor = "#FFF8DB";
      percentColor = "#F7921B";
    } else if (score <= 49.99) {
      backgroundColor = "#FFEEEE";
      percentColor = "#FF4141";
    } else {
      backgroundColor = "#FFEEEE";
      percentColor = "#FF4141";
    }

    return {
      backgroundColor,
      percentColor,
    };
  }

  static getBgAndColorBasedScore(
    score: number,
  ): { chartBgImageUrl: string; color: string } | null {
    if (score >= 80) {
      return {
        chartBgImageUrl: greenChart,
        color: "#E3FFF5", // Blue color
      };
    } else if (score >= 50 && score <= 79.99) {
      return {
        chartBgImageUrl: yellowChart,
        color: "#FFF8DB", // Yellow color
      };
    } else if (score <= 49.99) {
      return {
        chartBgImageUrl: redChart,
        color: "#FFEEEE", // Pink color
      };
    }
    return null;
  }

  static getBgImgAndColorBasedScore(
    score: number,
  ): { color: string; trendImg: string } | null {
    if (score >= 80) {
      return {
        color: "#E3FFF5", // Green background
        trendImg: greenScore,
      };
    } else if (score >= 50 && score <= 79) {
      return {
        color: "#FFF8DB", // Yellow background
        trendImg: yellowScore,
      };
    } else {
      return {
        color: "#FFEEEE", // Red background
        trendImg: redScore,
      };
    }

    return null;
  }

  static getBgImgAndColorBasedProgress(
    score: number,
  ): { color: string; trendImg: string; fontColor: string } | null {
    if (score === +1) {
      return {
        color: "#E3FFF5", // Green background
        trendImg: greenScore,
        fontColor: "#24C782",
      };
    } else if (score === 0) {
      return {
        color: "#FFF8DB", // Yellow background
        trendImg: yellowScore,
        fontColor: "#F7921B",
      };
    } else if (score === -1) {
      return {
        color: "#FFEEEE", // Red background
        trendImg: redScore,
        fontColor: "#FF4141",
      };
    } else if (score === null) {
      return {
        color: "#E2EFFF",
        trendImg: "",
        fontColor: "#000000",
      };
    }

    return null;
  }
  static getBgImgAndColorBasedProgressV2(
    score: number,
  ): { color: string; trendImg: string; fontColor: string } | null {
    if (score === +1) {
      return {
        color: "#E3FFF5", // Green background
        trendImg: greenTrend,
        fontColor: "#00a862",
      };
    } else if (score === 0) {
      return {
        color: "#FFF8DB", // Yellow background
        trendImg: yellowTrend,
        fontColor: "#d38b01",
      };
    } else if (score === -1) {
      return {
        color: "#FFEEEE", // Red background
        trendImg: redTrend,
        fontColor: "#eb4c3d",
      };
    } else if (score === null) {
      return {
        color: "#E2EFFF",
        trendImg: "",
        fontColor: "#000000",
      };
    }

    return null;
  }

  static getBgColorBasedProgress(
    score: number,
  ): { color: string; trendImg: string } | null {
    if (score >= 80) {
      return {
        color: "#E3FFF5", // Green background
        trendImg: greenScore,
      };
    } else if (score >= 50 && score <= 79.99) {
      return {
        color: "#FFF8DB", // Yellow background
        trendImg: yellowScore,
      };
    } else if (score <= 49.99) {
      return {
        color: "#FFEEEE", // Red background
        trendImg: redScore,
      };
    } else if (score === null) {
      return {
        color: "#E2EFFF",
        trendImg: "",
      };
    }

    return null;
  }

  static getBarClass = (score: number): string => {
    if (score > 80) {
      return "#43a047";
    } else if (score > 50 && score <= 80) {
      return "#f7d41b";
    } else {
      return "#d13b3b";
    }
  };

  static getGridColor = (progress: number | null) => {
    return "#ccdcf0ff"; // default blue
  };

  static getSkillName(name: string) {
    switch (name) {
      case "Information & Communication Technology":
        return "Digital Tech";
      case "Media Literacy":
        return "Media Studies";
      case "Information Literacy":
        return "Data Insights";
      case "Collaboration":
        return "Collaboration";
      case "Critical Thinking & Problem Solving":
        return "Problem Solving";
      case "Communication":
        return "Communication";
      case "Creativity & Innovation":
        return "Innovation";
      case "Flexibility & Adaptability":
        return "Adaptability";
      case "Productivity & Accountability":
        return "Efficiency";
      case "Initiative & Self-Direction":
        return "Self Direction";
      case "Leadership & Responsibility":
        return "Leadership";
      case "Social & Cross-Cultural Skills":
        return "Social Literacy";
      case "Global Awareness":
        return "Global Insights";
      case "Financial, Economic, Business, & Entrepreneurial Literacy":
        return "Entrepreneurial";
      case "Civic Literacy":
        return "Civic Literacy";
      case "Health Literacy":
        return "Health Living";
      case "Environmental Literacy":
        return "Environmental";
      case "STEM Awareness":
        return "STEM";
      default:
        return name;
    }
  }

  static getToolTipName(name: string | null): string | null {
    switch (name) {
      case "Digital Tech":
        return "Information & Communication Technology";
      case "Media Studies":
        return "Media Literacy";
      case "Data Insights":
        return "Information Literacy";
      case "Collaboration":
        return "Collaboration";
      case "Problem Solving":
        return "Critical Thinking & Problem Solving";
      case "Communication":
        return "Communication";
      case "Innovation":
        return "Creativity & Innovation";
      case "Adaptability":
        return "Flexibility & Adaptability";
      case "Efficiency":
        return "Productivity & Accountability";
      case "Self Direction":
        return "Initiative & Self-Direction";
      case "Leadership":
        return "Leadership & Responsibility";
      case "Social Literacy":
        return "Social & Cross-Cultural Skills";
      case "Global Insights":
        return "Global Awareness";
      case "Entrepreneurial":
        return "Financial, Economic, Business, & Entrepreneurial Literacy";
      case "Civic Literacy":
        return "Civic Literacy";
      case "Health Living":
        return "Health Literacy";
      case "Environmental":
        return "Environmental Literacy";
      case "STEM":
        return "STEM Awareness";
      default:
        return name;
    }
  }

  static formatLocalTime = (): string => {
    const now = new Date();
    const timeZoneOffsetMinutes = now.getTimezoneOffset();
    const hoursOffset = Math.floor(Math.abs(timeZoneOffsetMinutes) / 60);
    const minutesOffset = Math.abs(timeZoneOffsetMinutes % 60);
    const sign = timeZoneOffsetMinutes <= 0 ? "+" : "-";
    const formattedHours = hoursOffset.toString().padStart(2, "0");
    const formattedMinutes = minutesOffset.toString().padStart(2, "0");
    return `${sign}${formattedHours}:${formattedMinutes}`;
  };

  static utcToLocalString = (utcInput: string): string => {
    const utcDate = new Date(utcInput);
    const localMs = utcDate.getTime() - utcDate.getTimezoneOffset() * 60000;
    const localDate = new Date(localMs);
    const Y = localDate.getFullYear();
    const M = String(localDate.getMonth() + 1).padStart(2, "0");
    const D = String(localDate.getDate()).padStart(2, "0");
    const h = String(localDate.getHours()).padStart(2, "0");
    const m = String(localDate.getMinutes()).padStart(2, "0");
    const s = String(localDate.getSeconds()).padStart(2, "0");
    return `${Y}/${M}/${D}, ${h}:${m}:${s}`;
  };

  static setFaviconTitle = (url: string | null, title: string | null) => {
    if (url) {
      const favicon = document.querySelector(
        "link[rel~='icon']",
      ) as HTMLLinkElement;
      if (favicon) {
        favicon.href = url;
      }
    } else {
      const favicon = document.querySelector(
        "link[rel~='icon']",
      ) as HTMLLinkElement;
      if (favicon) {
        favicon.href = jozunaLogo;
      }
    }
    if (title) {
      document.title = title;
    } else {
      document.title = "JOZUNA";
    }
  };

  static findOffsetDuration(): { offset: string } {
    const now = new Date();
    const localTimeZoneOffset = now.getTimezoneOffset();
    const hours = Math.floor(Math.abs(localTimeZoneOffset) / 60);
    const minutes = Math.abs(localTimeZoneOffset) % 60;
    const formattedTimeZoneOffset = `${
      localTimeZoneOffset < 0 ? "+" : "-"
    }${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
    return { offset: formattedTimeZoneOffset };
  }

  static utilityTimeForEachQuestion = (startTimePerQuestions: Date) => {
    const currentTime = new Date();
    const elapsedMilliseconds =
      currentTime.getTime() - startTimePerQuestions.getTime();
    return Math.floor(elapsedMilliseconds / 1000);
  };

  static getBrowserInfo = (): BrowserInfo => {
    if (isChrome) {
      return { type: BrowserType.Chrome, version: browserVersion };
    } else if (isSafari) {
      return { type: BrowserType.Safari, version: browserVersion };
    } else {
      return { type: BrowserType.Unknown, version: "Unknown" };
    }
  };

  static loginTimeFormatLocalTime = (utcTimeString: string): string => {
    try {
      const utcDate = parse(
        utcTimeString.replace(" (UTC)", ""),
        "MMMM d, yyyy, h:mm a",
        new Date(),
      );
      const timezoneOffsetMinutes = new Date().getTimezoneOffset();
      const localDate = new Date(
        utcDate.getTime() - timezoneOffsetMinutes * 60 * 1000,
      );
      return format(localDate, "MMMM d, yyyy, h:mm a");
    } catch (error) {
      return "Invalid date";
    }
  };

  static parseUtcToLocalDate = (utcString: string): Date => {
    const isoString = utcString.replace(/\//g, "-").replace(", ", "T") + "Z";
    const date = new Date(isoString);
    return date;
  };

  static formatAssessmentTimeLeft = (timeStr: string): string => {
    const [daysStr, hoursStr, minutesStr] = timeStr.split(":");
    const days = parseInt(daysStr);
    const hours = parseInt(hoursStr);
    const minutes = parseInt(minutesStr);
    let result = "Remaining ";
    if (days > 0) result += `${days} Day${days > 1 ? "s" : ""} `;
    if (hours > 0) result += `${hours} Hour${hours > 1 ? "s" : ""} `;
    if (minutes > 0) result += `${minutes} Minute${minutes > 1 ? "s" : ""}`;
    return result.trim();
  };
  static formatAssessmentTimeLeftV2 = (timeStr: string): string => {
    const [daysStr, hoursStr, minutesStr] = timeStr.split(":");
    const days = parseInt(daysStr);
    const hours = parseInt(hoursStr);
    const minutes = parseInt(minutesStr);

    let result = "";
    if (days > 0) result += `${days} Day${days > 1 ? "s" : ""} `;
    if (hours > 0) result += `${hours} Hour${hours > 1 ? "s" : ""} `;
    if (minutes > 0) result += `${minutes} Minute${minutes > 1 ? "s" : ""}`;

    return result.trim() + " Remaining";
  };
  static getAssessmentCompletionPercentage = ({
    currentCounter,
    totalQuestions,
  }: {
    currentCounter: number;
    totalQuestions: number;
  }): number => {
    if (!totalQuestions) return 0;

    return Number(((currentCounter / totalQuestions) * 100).toFixed(1));
  };
  static getAssessmentTimeWarning = (
    item: any,
    withoutLeftTime: boolean,
  ): string | null => {
    const currentTime = new Date();
    const assessmentStartTime = CommonUtils.parseUtcToLocalDate(
      item.assessment_start_time,
    );
    const assessmentExpirySeconds = item.assessment_expiry;
    const assessmentDurationMinutes = item.assessment_duration;
    const timeSpendSeconds = Number(item.time_spend || 0);
    const assessmentEndTime = new Date(
      assessmentStartTime.getTime() + assessmentExpirySeconds * 1000,
    );
    let proposedCandidateEndTime: Date;

    if (item.status === "Resume") {
      const totalDurationMs = assessmentDurationMinutes * 60 * 1000;
      const timeSpentMs = timeSpendSeconds * 1000;
      const remainingMs = Math.max(0, totalDurationMs - timeSpentMs);
      proposedCandidateEndTime = new Date(currentTime.getTime() + remainingMs);
    } else {
      proposedCandidateEndTime = new Date(
        currentTime.getTime() + assessmentDurationMinutes * 60 * 1000,
      );
    }

    if (proposedCandidateEndTime > assessmentEndTime) {
      if (withoutLeftTime) {
        const diffMs = assessmentEndTime.getTime() - currentTime.getTime();
        const totalMinutes = Math.ceil(diffMs / 1000 / 60);
        const hoursLeft = Math.floor(totalMinutes / 60);
        const daysLeft = Math.floor(hoursLeft / 24);
        const minutesLeft = totalMinutes % 60;
        let warningText = "The exam will end in Remaining ";

        if (daysLeft > 0)
          warningText += `${daysLeft} Day${daysLeft > 1 ? "s" : ""} `;
        if (hoursLeft % 24 > 0)
          warningText += `${hoursLeft % 24} Hour${
            hoursLeft % 24 > 1 ? "s" : ""
          } `;
        if (minutesLeft >= 0)
          warningText += `${minutesLeft === 0 ? 1 : minutesLeft} Minute${
            minutesLeft === 1 ? "" : "s"
          }`;
        warningText +=
          ". Your assessment will be auto-submitted when time expires.";
        return warningText;
      } else {
        return `The exam will end in ${CommonUtils.formatAssessmentTimeLeft(
          item.assessment_entity_time_left,
        )}. Your assessment will be auto-submitted when time expires.`;
      }
    }
    return null;
  };
}

export default CommonUtils;
